module.exports = __webpack_public_path__ + "static/media/sologo.140d6060.png";